import { Form, SelectProps } from 'antd';
import { FormProps } from 'antd/lib';
import { useMemo } from 'react';
import { useOutletContext } from 'react-router';

import useFormInitialSet from '@/hooks/useFormInitialSet';
import { useSelectScrollSearch } from '@/hooks/useSelectScrollSearch';
import { useSelectPropsWithInitial } from '@/hooks/useSelectWithInitialValue';
import { RESOURCES } from '@/Resources';

const useServiceOrderFilter = (formProps: FormProps, filters: any[]) => {
  const { form } = formProps;
  const companyId = Form.useWatch('company', formProps.form);
  const initialValues: Record<string, any> = useMemo(
    () =>
      Object.fromEntries(
        filters.map(filter => {
          const valueParsed = parseInt(filter.value, 10);
          const value = isNaN(valueParsed) ? filter.value : valueParsed;

          return [filter.field, value];
        }),
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useFormInitialSet(form, initialValues, [
    {
      watchField: 'company',
      resetFields: ['movil'],
    },
  ]);

  const { companySelectProps, technicianSelectProps } = useOutletContext<{
    companySelectProps: SelectProps;
    technicianSelectProps: SelectProps;
  }>();
  const { selectProps: ticketsSelectProps } = useSelectScrollSearch({
    resource: RESOURCES.TICKETS,
    optionLabel: (item: any) =>
      `${item.id} - ${item.title ? item.title : item.ticket_title_str ? item.ticket_title_str : '-'}`,
    optionValue: (item: any) => item.id,
    queryOptions: {
      meta: { empresa: companyId },
      queryKey: ['tickets', { empresa: companyId }],
    },
    meta: { saveItem: true },
  });
  const technicianSelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: technicianSelectProps,
    resource: 'technicians',
    initialValue: initialValues.technician,
    labelKey: 'nombre',
    valueKey: 'id',
  });
  const companySelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: companySelectProps,
    resource: 'empresas',
    initialValue: initialValues.company,
    labelKey: 'full_name',
    valueKey: 'id',
  });
  const ticketSelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: ticketsSelectProps,
    resource: RESOURCES.TICKETS,
    initialValue: initialValues.tickets,
    labelKey: (item: any) =>
      `${item.id} - ${item.title ? item.title : item.ticket_title_str ? item.ticket_title_str : '-'}`,
    valueKey: 'id',
  });

  return {
    companySelectProps: companySelectPropsWithInitials,
    technicianSelectProps: technicianSelectPropsWithInitials,
    ticketSelectProps: ticketSelectPropsWithInitials,
  };
};

export default useServiceOrderFilter;
